import { Music2 } from 'lucide-react'
import type { ThemeSong } from '@/hooks/useInstructorThemeStats'
import { formatPrecise } from '@/lib/format'
import { workoutNouns } from '@/lib/discipline'

interface SongLeaderboardProps {
  songs: ThemeSong[]
}

// A theme like "80s" can span an instructor's classes across more than
// one discipline, so "workouts" rather than "rides".
const { plural: WORKOUTS } = workoutNouns('all')

export function SongLeaderboard({ songs }: SongLeaderboardProps) {
  const max = Math.max(...songs.map((s) => s.ride_count), 1)

  return (
    <ul className="flex flex-col gap-3">
      {songs.map((song, index) => (
        <li key={song.id} className="flex items-center gap-3">
          <span className="w-4 shrink-0 text-right text-sm tabular-nums text-muted-foreground">
            {index + 1}
          </span>
          {song.album_image_url ? (
            <img
              src={song.album_image_url}
              alt=""
              className="size-10 shrink-0 rounded object-cover ring-1 ring-border"
            />
          ) : (
            <div className="flex size-10 shrink-0 items-center justify-center rounded bg-muted text-muted-foreground">
              <Music2 className="size-4" />
            </div>
          )}
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <div className="flex items-baseline justify-between gap-2">
              <span className="truncate text-sm font-medium">{song.title}</span>
              <span className="shrink-0 text-sm tabular-nums text-muted-foreground">
                {formatPrecise(song.ride_count)} {WORKOUTS}
              </span>
            </div>
            <div className="flex items-center justify-between gap-2">
              <span className="truncate text-xs text-muted-foreground">{song.artists.join(', ')}</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
              <div
                className="h-full rounded-full bg-primary"
                style={{ width: `${(song.ride_count / max) * 100}%` }}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}
